import { useState, useEffect } from "react";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    if (typeof window !== "undefined") {
      return document.documentElement.classList.contains("dark");
    }
    return false;
  });

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("skyboard_theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("skyboard_theme", "light");
    }
  }, [dark]);

  // Restore on mount
  useEffect(() => {
    const saved = localStorage.getItem("skyboard_theme");
    if (saved === "dark") {
      setDark(true);
    }
  }, []);

  return (
    <button
      onClick={() => setDark(prev => !prev)}
      className="p-2 rounded-md text-slate-400 hover:text-white hover:bg-slate-800 transition-colors"
      data-testid="theme-toggle-btn"
      title={dark ? "Light mode" : "Dark mode"}
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
